import type { FaireProductEntity } from "../../entity_types/product";

export const p_v6c88h69zr: FaireProductEntity = {
  token: "p_v6c88h69zr",
  type: "product",
  name: "18K Gold Filled Cubic Zirconia Solitaire Ring,SKU#X180C",
  brandToken: "b_4f46qpq5wu",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/dab24ece1db6b48b2a257d2dc1e50a4d7ea9673fefa5a63e5a2cbc125740ec7a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0256a8ad06da66866445fa42580d6a9fc607ac6ef59dd1cb51e01a06066a6322.jpeg",
    "https://cdn.faire.com/fastly/6b88e9df9d7d2881d6846fe66ce6236e2b935aac3befb45c67f41a2f5c996cef.jpeg",
    "https://cdn.faire.com/fastly/5ff39a7e51263a85aa9934633a940dda8a829a9745652628e681aa4556a1c82d.jpeg",
    "https://cdn.faire.com/fastly/f79a2767f1bff52db8f8a6d23dc0b90fb024f4dcfb76bc298624debc983d63ae.jpeg",
  ],
  priceDollars: 9.56,
  description:
    "Qty:1pc pack\nMaterial: Brass, Cubic Zirconia, 18k Gold Filled\nSize: 19.5x19.8mm\n",
  tags: [],
  msrpDollars: 19.12,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:43.370Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
